import React from 'react';
import { FontSearchInput } from './FontSearchInput';
import { FontCategoryTabs } from './FontCategoryTabs';
import { FontList } from './FontList';
import { FontWeightSelector } from './FontWeightSelector';

export default function FontPickerModal({
  open,
  search,
  onSearch,
  category,
  onCategoryChange,
  fonts,
  loading,
  error,
  selectedFamily,
  selectedWeight,
  onSelectFamily,
  onSelectWeight,
  onCancel,
  onApply,
}) {
  if (!open) return null;

  return (
    <div className="mp-font-picker-modal" role="dialog" aria-modal="true" aria-label="Selecionar fonte">
      <div className="mp-font-picker-modal__header">
        <FontSearchInput value={search} onSearch={onSearch} />
        <FontCategoryTabs value={category} onChange={onCategoryChange} />
      </div>

      <div className="mp-font-picker-modal__body">
        <FontList
          fonts={fonts}
          loading={loading}
          error={error}
          selectedFamily={selectedFamily}
          onSelect={onSelectFamily}
        />
      </div>

      <div className="mp-font-picker-modal__footer">
        <FontWeightSelector
          fonts={fonts}
          selectedFamily={selectedFamily}
          value={selectedWeight}
          onChange={onSelectWeight}
        />

        <div className="mp-font-picker-modal__actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
          <button type="button" className="btn btn-primary" onClick={onApply}>Aplicar</button>
        </div>
      </div>
    </div>
  );
}
